import React, {useState} from 'react';
import './iconButton.css'

function IconButton({icon, className, onClick, disabled, title = "", id, style}){

    const [loading, setLoading] = useState(false);

    async function clickedbutton(e) {
        if(loading || disabled){
            return;
        }
        setLoading(true);
        if(onClick){
            await onClick(e);
        }
        setLoading(false);
    }

    return <div style={style} id={id} className={className + ' ' + (!disabled && " iconButton_div")} title={title}  onClick={e => clickedbutton(e)}>
        <i  className={icon +" " + ((loading || disabled) && "disabled")}></i>
    </div>
}

export default IconButton;
